import { Box, Typography, Button, Grid, IconButton } from "@mui/material";
import React from "react";
import dayjs from "dayjs";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function AppointmentDashboardCard({
  valuet,
  item,
  onClick,
  callback,
  value,
}) {
  const {
    appointmentId = "",
    customerName = "",
    mobileNumber = "",
    profileMobileNumber = "",
    services = [],
    date = "",
    hour = "",
    minute = "",
    noon = "",
    employee = "",
  } = item || {};

  const dateObj = dayjs(date);
  const formattedDate = dateObj.isValid() ? dateObj.format("DD MMM YYYY") : "";

  const serviceNames =
    services.length > 0
      ? services
          .map((s) => s?.service)
          .filter(Boolean)
          .join(", ")
      : "-";

  function convertTo12HourFormat(hour24, minute) {
    const hour = hour24 % 12 || 12;
    const min = minute?.toString().padStart(2, "0");
    const noon = hour24 >= 12 ? "PM" : "AM";
    return `${hour} : ${min} ${noon}`;
  }
  const displayTime = convertTo12HourFormat(hour, minute);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        minWidth: "100%",
        width: "max-content",
        background: "#E8E8FF",
        borderRadius: 2,
        padding: "12px 6px",
        mb: 1.5,
        cursor: "pointer",
      }}
    >
      <Box
        sx={{
          width: "120px",
          px: { sm: "22px", xs: "1px" },

          color: "#000000",
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          marginLeft: "10px",
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
        >
          {" "}
          {appointmentId ?? "-"}
        </Typography>
      </Box>
      <Box
        sx={{
          width: { xs: "120px", sm: "180px" },

          color: "#000000",
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
          textAlign: "left",
          pl: { xs: 3 },
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",

            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
        >
          {" "}
          {customerName ?? "-"}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: { xs: "120px", sm: "150px" },
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            whiteSpace: "nowrap",
            textAlign: "right",
            pl:1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
            cursor: "pointer",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
          onClick={() =>
            window.open(
              `https://web.whatsapp.com/send?phone=${mobileNumber}`,
              "_blank"
            )
          }
        >
          {mobileNumber ?? "-"}
        </Typography>

        {mobileNumber && (
          <IconButton
            size="small"
            sx={{ p: 0 }}
            onClick={() =>
              window.open(
                `https://web.whatsapp.com/send?phone=${mobileNumber}`,
                "_blank"
              )
            }
          >
            <WhatsAppIcon
              sx={{
                color: "white",
                fontSize: 20,
                borderRadius: "50%",
                backgroundColor: "#25D366",
                p: "3px",
              }}
            />
          </IconButton>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", 
          color: "#000000",
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
          marginLeft: "30px",
          width: { xs: "120px", sm: "140px" },
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100px", 
            cursor: "pointer",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
          onClick={() =>
            window.open(
              `https://web.whatsapp.com/send?phone=${profileMobileNumber}`,
              "_blank"
            )
          }
        >
          {profileMobileNumber || ""}
        </Typography>

        {profileMobileNumber && (
          <IconButton
            size="small"
            onClick={() =>
              window.open(
                `https://web.whatsapp.com/send?phone=${profileMobileNumber}`,
                "_blank"
              )
            }
            sx={{ flexShrink: 0 }} // prevents shrinking
          >
            <WhatsAppIcon
              sx={{
                color: "white",
                fontSize: 22,
                padding: "3px",
                borderRadius: "19px",
                backgroundColor: "#25D366",
              }}
            />
          </IconButton>
        )}
      </Box>

      <Box
        sx={{
          width: {sm:"200px", xs:"180px", md:"200px" ,lg:"200px"},
          color: "#000000",
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
          textAlign: "left",
          // overflow: "hidden",
          // textOverflow: "ellipsis",
          whiteSpace: "normal",
          pl: { xs: 10, sm:8 },
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",
            // maxWidth: "100px", 
            //   width:"100%",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
        >
          {serviceNames}
        </Typography>
      </Box>
      <Box
        sx={{
          width: {sm:"150px", xs:"160px", md:"170px", lg:"180px"},
          color: "#000000",
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
          textAlign: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          marginLeft: {sm:"2px", xs:"8px", md:"1px", lg:"0px"},
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
        >
          {" "}
          {formattedDate} {displayTime}
        </Typography>
      </Box>
      {/* <Box
                sx={{
                    width: "200px",
                    color: "black",
                    fontSize: 15,
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                {employee ?? "-"}
            </Box> */}
      {value === "Unassigned" && (
        <Box
          sx={{
            width: "140px",
            color: "black",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
            textAlign: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            paddingLeft: " 30px",
          }}
        >
          <Button
            variant="contained"
            sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
            fullWidth
            onClick={() => onClick(item)}
          >
            Assign
          </Button>
        </Box>
      )}
      {valuet == "Assigned" && value !== "Unassigned" && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "320px",
          }}
        >
          <Button
            variant="contained"
            sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
            onClick={() => onClick(item)}
          >
            Update
          </Button>
          <Button
            variant="contained"
            sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
            onClick={() => {
              callback({ api: "complete" });
            }}
          >
            Completed
          </Button>
          <Button
            variant="contained"
            sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
            onClick={() => {
              callback({ api: "cancel" });
            }}
          >
            Cancelled
          </Button>
        </Box>
      )}
    </Box>
  );
}
